import { render, staticRenderFns } from "./AddCompaniesModal.vue?vue&type=template&id=2166be9c&scoped=true"
import script from "./AddCompaniesModal.vue?vue&type=script&lang=js"
export * from "./AddCompaniesModal.vue?vue&type=script&lang=js"
import style0 from "./AddCompaniesModal.vue?vue&type=style&index=0&id=2166be9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166be9c",
  null
  
)

export default component.exports